import settings from '@/settings'

let get = () => {
  return fetch(`${settings.apetrusApi}/termosdeuso/posto/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default'
  })
}

export default {
  get
}
